import React from "react";
import MediumButton from "../MediumButton";
import DirectSearchModal from "../search/DirectSearchModal";
import { useTransition } from "react-transition-state";
import type { Masters } from "~/types";
import { useSearch } from "~/context/SearchContext";

type Props = {
  masters: Masters;
};

{
  /* sp時のみ表示 */
}
const SpSearchButton: React.FC<Props> = ({ masters }) => {
  const [visible, setVisible] = React.useState(false);
  const [number, setNumber] = React.useState(0);

  const {
    conditions: selectedConditions,
    addCondition: handleAddCondition,
    removeCondition: handleSubCondition,
    resetConditions: handleResetConditions,
    setConditions: setSelectedConditions,
    setAppliedConditions,
    initialState,
  } = useSearch();

  // モーダル開閉アニメーション用
  const [{ status }, transitionToggle] = useTransition({
    timeout: 1,
    preEnter: true,
  });

  const stateToggle = () => {
    setVisible(!visible);
    setNumber(0);
    transitionToggle(true);
  };

  // この条件で検索するボタンクリック時の挙動
  const handleVisibleToFalse = () => {
    transitionToggle(false);
    setSelectedConditions((current) => ({ ...current }));
    setTimeout(() => {
      setVisible(false);
    }, 1000);
  };

  // 閉じる（x）ボタンクリック時の挙動
  const handleVisibleToFalseForClose = () => {
    transitionToggle(false);
    setSelectedConditions((current) => ({ ...current }));
    setTimeout(() => {
      setVisible(false);
    }, 1000);
  };

  return (
    <>
      <MediumButton
        handler={stateToggle}
        text="検索条件を変更する"
        color="white"
      ></MediumButton>
      <div className={`group ${status}`}>
        {visible && (
          <DirectSearchModal
            setVisible={setVisible}
            activeTab={number}
            masters={masters}
            handleAddCondition={handleAddCondition}
            handleSubCondition={handleSubCondition}
            handleResetConditions={handleResetConditions}
            handleVisibleToFalse={handleVisibleToFalse}
            handleVisibleToFalseForClose={handleVisibleToFalseForClose}
            selectedConditions={selectedConditions}
            setSelectedConditions={setSelectedConditions}
            setAppliedConditions={setAppliedConditions}
            initialState={initialState}
          />
        )}
      </div>
    </>
  );
};

export default SpSearchButton;
